export default "__VITE_ASSET__Bv6p5_vH__"